import { $ } from '@vaaas/fpts/dom';
import { floating_toolbar_buttons, floating_toolbar_position, showing_floating_toolbar } from './state';
import {
    uid_deselect_all_objects,
    uid_hide_rigid_move_manipulator,
    uid_toggle_edge_tangent_manipulators,
} from '@frontend/ui_display';
import App from '@frontend/application-container';
import { button_selectors, buttons } from './data';
import { in_tutorial } from '@frontend/state';
import { ModalButton } from './components/modal-button';
import { pointer_normalised } from '@frontend/pointer';
import { from_normalized_to_actual_screen_coordinates } from '@frontend/utility';

const is_visible = (x: unknown): x is HTMLElement =>
    x instanceof HTMLElement && !x.classList.contains('disabled');

export const count_of_visible_icons = () =>
    button_selectors
        .map($)
        .filter(is_visible)
        .length;

export function hide_floating_toolbar() {
    showing_floating_toolbar.value = false;
}

export function show_floating_toolbar() {
    if (App.state.is_demo || in_tutorial())
        return;

    // Hide rigid move manipulator if visible
    if (uid_state.edge_tangent_manipulators_are_shown)
        uid_toggle_edge_tangent_manipulators();
    else if (App.state.rigid_move_manipulator) {
        uid_hide_rigid_move_manipulator(false, 0, true);
        uid_deselect_all_objects();
    }

    recalculate_floating_toolbar_buttons();
    recalculate_floating_toolbar_position();

    showing_floating_toolbar.value = true;
}

function recalculate_floating_toolbar_buttons() {
    floating_toolbar_buttons.value =
        Object.entries(buttons)
            .map(([k, v]) => ModalButton(k, v.label, v.shortcut));
}

function recalculate_floating_toolbar_position() {
    showing_floating_toolbar.value;
    const nicons = count_of_visible_icons();
    if (nicons < 1) return;

    const floating_toolbar_height = Math.ceil(nicons/6) * 64 + 115;
    const floating_toolbar_width = 480;
    const coords = from_normalized_to_actual_screen_coordinates(pointer_normalised);

    const x = Math.min(
        coords.x + 10,
        App.state.canvas.width - floating_toolbar_width,
    );

    const y = Math.min(
        coords.y + 10,
        App.state.canvas.height - floating_toolbar_height,
    );

    floating_toolbar_position.value = { left: x, top: y };
}
